import { render } from "./SurveyQuestionSections.vue?vue&type=template&id=36d9dde8&scoped=true"
import script from "./SurveyQuestionSections.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionSections.vue?vue&type=script&lang=js"

import "./SurveyQuestionSections.vue?vue&type=style&index=0&id=36d9dde8&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d9dde8"]])

export default __exports__